// extracted by mini-css-extract-plugin
export default {"link":"ContactCard_link__Vfb8R","linkText":"ContactCard_linkText__SyBnG","wrapper":"ContactCard_wrapper__K4HB+","content":"ContactCard_content__2n3vs"};